import script from "./TelefoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TelefoneInput.vue?vue&type=script&setup=true&lang=js"

import "./TelefoneInput.vue?vue&type=style&index=0&id=1241ad93&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1241ad93"]])

export default __exports__